export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/homeIcon.40b00195.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};